export function capitalizeEachWord(name: string): string {
	if (typeof name !== 'string') return name
	const words = name.split(' ')
	const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
	return capitalizedWords.join(' ')
}
